/**
 * 이미지 전체화면 뷰어 (핀치줌 + 갤러리 네비게이션 + 옵션 삭제)
 *
 * 사용법
 * ─────
 *  // 단일 이미지 (URL 직접)
 *  $j.Ui.ZoomPhoto.open(imageUrl);
 *
 *  // 단일 이미지 (path/host)
 *  $j.Ui.ZoomPhoto.open(null, { path, host });
 *
 *  // 갤러리 모드 (이전/다음 네비게이션)
 *  $j.Ui.ZoomPhoto.open(null, {
 *      items: [{ path, host, ...customFields }, ...],
 *      index: 0,
 *      deletable: true,
 *      shareable: true,
 *      downloadable: true,
 *      actions: [{ label: '스티커인증샷', onClick: (item, index) => {...} }],
 *  });
 *
 * 옵션
 * ─────
 *  path, host    단일 이미지용
 *  items[]       갤러리 모드. 각 항목은 { path, host } 또는 { url } 필수.
 *                `caption` 을 주면 사진마다 하단에 제목 1줄, `meta` 를 주면 그 아래 작은 글씨로
 *                부가정보가 뜬다 (넘길 때마다 그 사진 것으로 바뀐다).
 *                나머지 커스텀 필드는 그대로 보존되어 삭제 이벤트·actions 콜백으로 전달됨.
 *  index         시작 인덱스 (default 0)
 *  deletable     true 시 삭제 버튼 노출
 *  shareable     true 시 공유 버튼 노출 ($j.F.App.shareFile 호출)
 *  downloadable  true 시 다운로드 버튼 노출 ($j.F.App.downloadImage 호출)
 *  actions[]     상단 가운데 글자 버튼 [{ label, onClick(item, index) }].
 *                뷰어는 "지금 보고 있는 사진"만 넘기고 무엇을 할지는 부르는 쪽이 정한다 —
 *                호출자별 업무(예: 불러톡의 스티커인증샷 지급)를 이 컴포넌트가 알 이유가 없다.
 *                `label` 은 글자 대신 함수 `(item, index) => 글자` 도 된다 — 넘길 때마다·누른 뒤마다 다시 그린다
 *                (예: 사진마다 「이 사진 선택」/「✓ 선택됨」). `pressed(item, index) => bool` 을 주면 눌린 모양
 *                (`.is-on`, aria-pressed)도 함께 바뀐다. 글자를 준 호출은 지금과 같다.
 *  topNotice     상단에 흰색 안내 텍스트 1줄 (이번 호출에만 적용)
 *  size          'full'(기본, 화면 가득) | 'fit'(적당한 크기로 가운데). 'fit' 은 뒤 화면이 비쳐 보여
 *                "잠깐 크게 본다"는 느낌이 된다 — 관리자 목록에서 한 장씩 확인할 때 쓴다.
 *                **기본은 'full' 이다** — 앱의 사진 보기는 전체화면이 맞고, 그 동작을 바꾸지 않는다.
 *
 *                ⚠ **`size` 를 주지 않은 호출은 지금까지와 한 칸도 다르지 않다.** 이 옵션으로
 *                  들어온 코드는 전부 `size === 'fit'` 뒤에서만 돈다 — 상자 클래스도, 닫기 버튼
 *                  위치 계산(_placeClose)도, 창 크기 추종(resize)도 그렇다. 호출처가 16곳이라
 *                  이 경계가 무너지면 모바일 사진 보기까지 같이 흔들린다.
 *                  (확인 2026-09-22: 기존 호출은 오버레이에 --fit 클래스도, 닫기 버튼 인라인
 *                   스타일도 붙지 않는다)
 *  loop          false 면 끝에서 멈춘다 — 마지막 장에서 '다음', 첫 장에서 '이전' 이 흐려지고 눌리지 않는다.
 *                **기본은 true(지금까지처럼 끝에서 처음으로 돈다)** — 안 준 호출은 동작이 같다.
 *                몇 장인지 세며 넘기는 화면(관리자 작업사진 갤러리)은 돌아가면 끝을 모른다.
 *  maxWidth      'fit' 일 때 가로 상한 (기본 1100px). 숫자면 px, 문자열이면 그대로 쓴다.
 *
 *                ⚠ `fit` 의 스타일은 `sass/shared/components/_zoom-photo.scss` 에 있고 이를
 *                  import 하는 사이트는 **adm · ma · b** 다. `/m/`(모바일)은 같은 클래스를
 *                  자체 사본(`mobile/features/_diary-photo.scss`)으로 갖고 있어 `fit` 이 없다 —
 *                  거기서 주면 조용히 전체화면으로 뜬다(동작은 깨지지 않는다).
 *  dock          true 면 버튼(actions)을 **아래 고정 줄**에 꽉 찬 폭으로 놓고, 그 위에 「2 / 12 · 설명」 한 줄.
 *                사진은 그 줄 위 공간에 맞춰 줄어 버튼에 가리지 않는다(위 가운데 버튼·아래 설명/카운터 대신 쓴다).
 *                **기본은 false** — 안 준 호출은 지금과 같다. 일지 사진 격자의 크게 보기가 쓴다(2026-10-27).
 *
 *                ⚠ `dock` 스타일은 모바일 사본(`mobile/features/_diary-photo.scss`)에만 있다 —
 *                  adm · ma · b 에서 주면 버튼이 스타일 없이 뜬다(`fit` 과 반대 방향).
 *  onShow        (item, index) — 보이는 사진이 바뀔 때마다(열 때 포함) 부른다. 큰 그림을 그때그때 받아 올 때 쓴다.
 *  backClose     true 면 안드로이드 뒤로가기로 뷰어만 닫는다 — 열 때 같은 주소 기록을 하나 얹고 popstate 로 닫는다
 *                (앱은 같은 주소 기록이면 goBack 해 웹이 덮인 것을 닫게 한다). ✕·배경으로 닫으면 그 기록을 history.back() 으로
 *                거둔다. BS 의 backClose 와 같은 꼴이라 시트 위에 떠도 뒤로가기 한 번 = 한 겹씩 닫힌다.
 *                **기본은 false** — 안 준 호출은 지금과 같다. 일지 사진 격자(사진 전체 허용)의 크게 보기가 쓴다(2026-10-27).
 *
 * 항목 바꾸기
 * ─────
 *  updateItem(where, patch) — 열린 뷰어의 항목 하나에 patch 를 덮는다. where 는 index 또는 `item => bool`.
 *  지금 보는 사진이면 그림만 바꿔 끼운다(확대 상태 유지) — 작은 그림을 먼저 띄우고 큰 그림이 오면 갈아 끼울 때.
 *
 * 삭제 이벤트
 * ─────
 *  삭제 버튼 클릭 → confirm → $j.Common.EventBus.trigger('zoomphoto:delete', { index, item })
 *  뷰어 내부 상태에서는 즉시 splice + 다음 사진으로 이동 (또는 마지막이면 자동 닫힘)
 *
 *  구독 예시:
 *    $j.Common.EventBus.on($j.getNS(this), 'zoomphoto:delete', (e, payload) => {
 *        const { index, item } = payload;
 *        // item.photoNum 등 호출 시 넘긴 커스텀 필드 사용 가능
 *    });
 */
import Util from '../Common/Util';

export default class ZoomPhoto {
    constructor() {
        this.$ov = null;
        this.items = [];
        this.index = 0;
        this.deletable = false;
        this.shareable = false;
        this.downloadable = false;
        this.actions = [];
        this.topNotice = '';
        this.dock = false;
        this.onShow = null;
        this.backClose = false;
        this._histOn = false;   // 뒤로가기용 기록을 얹어둔 상태인가
        this._onPop = null;
        this._resetZoom = () => {};
    }

    /**
     * @param {string|null} url
     * @param {object} [opts]
     */
    open(url, opts = {}) {
        // 모드 결정
        if (Array.isArray(opts.items) && opts.items.length) {
            this.items = opts.items.slice();
            this.index = Math.max(0, Math.min(opts.index || 0, this.items.length - 1));
        } else if (opts.path) {
            this.items = [{ path: opts.path, host: opts.host }];
            this.index = 0;
        } else if (url) {
            this.items = [{ url }];
            this.index = 0;
        } else {
            return;
        }

        this.deletable = !!opts.deletable;
        this.shareable = !!opts.shareable;
        this.downloadable = !!opts.downloadable;
        this.actions = Array.isArray(opts.actions)
            ? opts.actions.filter(a => a && a.label && typeof a.onClick === 'function')
            : [];
        this.topNotice = (opts.topNotice == null ? '' : String(opts.topNotice));
        this.loop = opts.loop !== false;
        // 아래 고정 줄 — 준 호출만. 안 준 호출은 지금처럼 위 가운데 버튼 + 아래 설명/카운터
        this.dock = !!opts.dock;
        this.onShow = typeof opts.onShow === 'function' ? opts.onShow : null;
        this.backClose = !!opts.backClose;
        // 크기 — 기본은 지금까지와 같은 전체화면이다. 'fit' 을 준 호출만 상자로 뜬다
        this.size = opts.size === 'fit' ? 'fit' : 'full';
        this.maxWidth = opts.maxWidth == null ? '1100px'
            : (typeof opts.maxWidth === 'number' ? opts.maxWidth + 'px' : String(opts.maxWidth));

        this._savedScrollY = window.scrollY;
        document.body.style.overflow = 'hidden';

        this._render();
        this._bind();
        this._show();
        if (this.backClose) this._pushHistory();
    }

    /**
     * @param {boolean} [fromPop] 뒤로가기(popstate)로 들어온 닫기인가. true 면 기록은 이미 되감겼다.
     *                            그 밖(✕·배경·Esc·호출부)은 열 때 얹은 기록을 history.back() 으로 거둔다(backClose 일 때만)
     */
    close(fromPop) {
        // 뒤로가기 기록 정리 — 리스너를 먼저 떼고 거둔다(내가 일으킨 popstate 에 다시 닫히지 않게)
        if (this._onPop) { window.removeEventListener('popstate', this._onPop); this._onPop = null; }
        const hadHist = this._histOn;
        this._histOn = false;
        if (hadHist && fromPop !== true) history.back();

        $(window).off('resize.zoomphoto');
        if (this.$ov) {
            this.$ov.remove();
            this.$ov = null;
        }
        document.body.style.overflow = '';
        $(document).off('.zoomphoto');
        this.items = [];
        this.index = 0;
        this.actions = [];
        this.dock = false;
        this.onShow = null;
        this.backClose = false;
    }

    /** 뒤로가기 몫의 기록(같은 주소)을 얹고 popstate 를 듣는다 — BS._pushHistory 와 같은 꼴 */
    _pushHistory() {
        if (this._histOn) return;
        this._histOn = true;
        history.pushState({ zoomphoto: 1 }, '', location.href);
        // popstate 는 등록된 리스너 전부에 간다. 되감은 뒤에도 현재 상태가 내 기록이면(= 내 위의 다른 겹이 빠진 것) 그대로 있는다
        this._onPop = () => {
            if (history.state && history.state.zoomphoto) return;
            this.close(true);
        };
        window.addEventListener('popstate', this._onPop);
    }

    // ─── 렌더링 ───────────────────────────────
    _render() {
        const delHtml = this.deletable ? `
            <button class="mc-fullscreen-del" aria-label="삭제">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"/>
                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                    <line x1="10" y1="11" x2="10" y2="17"/>
                    <line x1="14" y1="11" x2="14" y2="17"/>
                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                </svg>
            </button>
        ` : '';

        const shareHtml = this.shareable ? `
            <button class="mc-fullscreen-share" aria-label="공유">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="18" cy="5" r="3"/>
                    <circle cx="6" cy="12" r="3"/>
                    <circle cx="18" cy="19" r="3"/>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                </svg>
            </button>
        ` : '';

        const downloadHtml = this.downloadable ? `
            <button class="mc-fullscreen-download" aria-label="다운로드">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
            </button>
        ` : '';

        // 액션 버튼 — 상단 가운데. 좌상단 아이콘 3종(삭제·공유·다운로드)과 우상단 닫기 사이 자리다.
        // 여러 개면 가로로 나란히.
        const actionsHtml = (this.actions.length && !this.dock) ? `
            <div class="mc-fullscreen-actions">
                ${this.actions.map((a, i) => `
                    <button class="mc-fullscreen-action" data-act="${i}">${this._esc(this._actionLabel(a))}</button>
                `).join('')}
            </div>
        ` : '';

        // 아래 고정 줄(dock) — 정보 1줄 + 꽉 찬 버튼. 글자·눌림은 _show() 의 _refreshActions() 가 채운다
        const dockHtml = this.dock ? `
            <div class="mc-fullscreen-dock">
                <div class="mc-fullscreen-dock-info"></div>
                ${this.actions.map((a, i) => `<button class="mc-fullscreen-dock-btn" data-act="${i}"></button>`).join('')}
            </div>
        ` : '';

        // 상단 안내 (이번 호출에만 적용) — overlay 기준 절대 위치 + 높은 z-index 로 다른 요소 위에.
        // 어두운 배경에서도 잘 보이도록 살짝 반투명 박스 + 흰 글씨.
        const noticeHtml = this.topNotice ? `
            <div class="mc-fullscreen-notice" style="position:absolute;top:16px;left:60px;right:60px;z-index:9999;color:#fff;font-size:14px;font-weight:600;text-align:center;line-height:1.4;padding:10px 12px;background:rgba(0,0,0,.55);border:2px solid #FBBF24;border-radius:8px;pointer-events:none">
                ${this.topNotice.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}
            </div>
        ` : '';

        // nav/counter는 항상 DOM에 두고 _show()에서 가시성 토글
        this.$ov = $(`
            <div class="mc-fullscreen-overlay${this.size === 'fit' ? ' mc-fullscreen-overlay--fit' : ''}${this.dock ? ' mc-fullscreen-overlay--dock' : ''}"
                 ${this.size === 'fit' ? `style="--mc-fit-w:${this._esc(this.maxWidth)}"` : ''}>
                <button class="mc-fullscreen-close" aria-label="닫기">&times;</button>
                ${noticeHtml}
                ${delHtml}
                ${shareHtml}
                ${downloadHtml}
                <button class="mc-fullscreen-nav prev" aria-label="이전">&lsaquo;</button>
                <img alt="">
                <button class="mc-fullscreen-nav next" aria-label="다음">&rsaquo;</button>
                ${actionsHtml}
                <div class="mc-fullscreen-caption"></div>
                <div class="mc-fullscreen-counter"></div>
                ${dockHtml}
                <div class="mc-fullscreen-error"
                     style="display:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#aaa;font-size:14px;text-align:center;pointer-events:none;line-height:1.6">
                    ⚠<br>이미지를 불러올 수 없습니다
                </div>
            </div>
        `).appendTo('body');
    }

    /**
     * 닫기 버튼을 **사진의 오른쪽 위 모서리에** 얹는다 ('fit' 일 때만).
     *
     * 전체화면에서는 사진이 화면을 채우니 화면 모서리가 곧 사진 모서리다. 상자로 뜨면
     * 둘이 멀어져서, 화면 구석의 ✕ 가 이 사진의 것인지 뒤에 깔린 화면의 것인지 헷갈린다.
     *
     * 모서리에 **걸치게** 둔다 — 안쪽으로 넣으면 서류 귀퉁이의 글자를 가리고, 바깥에 띄우면
     * 다시 사진과 떨어진다. 사진 높이는 비율마다 달라 CSS 로는 못 맞추므로 그려진 크기를 잰다.
     */
    _placeClose() {
        if (this.size !== 'fit' || !this.$ov) return;
        const img = this.$ov.find('img')[0];
        const $btn = this.$ov.find('.mc-fullscreen-close');
        const r = img && img.getBoundingClientRect();
        if (!r || !r.width) return;

        const half = ($btn.outerWidth() || 36) / 2;   // 모서리에 중심을 맞춘다
        $btn.css({
            top: Math.max(4, r.top - half) + 'px',
            right: Math.max(4, window.innerWidth - r.right - half) + 'px',
            marginTop: 0,
        });

        // 이전/다음은 **화면 양끝 그대로** 둔다. 사진 옆에 붙이면 사진 크기마다 자리가 달라져
        // 연달아 넘길 때 손이 따라다녀야 한다 — 끝에 고정돼 있어야 같은 자리를 계속 누른다.
    }

    _show() {
        const item = this.items[this.index];
        if (!item) { this.close(); return; }
        const url = item.url || Util.getImageUrl(item.path, item.host, 'original');
        const img = this.$ov.find('img')[0];
        const $err = this.$ov.find('.mc-fullscreen-error');

        // 로드 시작 — 에러 메시지 일단 숨기고 이미지 보이게
        $err.hide();
        img.style.visibility = '';
        img.onload  = () => { img.style.visibility = '';       $err.hide(); this._placeClose(); };
        img.onerror = () => { img.style.visibility = 'hidden'; $err.show(); this._placeClose(); };
        img.src = url;

        // 사진마다 다른 설명 — 넘길 때 함께 바뀐다. `topNotice` 는 호출 1회분 고정이라
        // 갤러리에서는 지금 보는 것이 무엇인지 말해주지 못한다.
        const $cap = this.$ov.find('.mc-fullscreen-caption');
        if (item.caption || item.meta) {
            $cap.html(`<b>${this._esc(item.caption || '')}</b>`
                + (item.meta ? `<span>${this._esc(item.meta)}</span>` : '')).show();
        } else {
            $cap.hide().empty();
        }

        // 아이템 개수에 따라 nav/counter 가시성 갱신 (삭제 후에도 정확히 반영)
        const multi = this.items.length > 1;
        this.$ov.find('.mc-fullscreen-nav').toggle(multi);
        if (!this.loop) {
            this.$ov.find('.mc-fullscreen-nav.prev').toggleClass('is-end', this.index === 0);
            this.$ov.find('.mc-fullscreen-nav.next').toggleClass('is-end', this.index === this.items.length - 1);
        }
        this.$ov.find('.mc-fullscreen-counter')
            .toggle(multi)
            .text(multi ? `${this.index + 1} / ${this.items.length}` : '');

        this._resetZoom();

        // 아래 고정 줄 — 「2 / 12 · 설명」
        if (this.dock) {
            const info = [multi ? `${this.index + 1} / ${this.items.length}` : '', item.caption || ''].filter(Boolean).join(' · ');
            this.$ov.find('.mc-fullscreen-dock-info').text(info);
        }
        this._refreshActions();
        if (this.onShow) this.onShow(item, this.index);
    }

    // ─── 네비게이션 / 삭제 ─────────────────────
    _step(delta) {
        const len = this.items.length;
        if (len < 2) return;
        const next = this.index + delta;
        if (!this.loop && (next < 0 || next >= len)) return;
        this.index = (next + len) % len;
        this._show();
    }

    _onShareClick() {
        const item = this.items[this.index];
        if (!item) return;
        const url = item.url || Util.getImageUrl(item.path, item.host, 'original');
        if (!$j.F.App.shareFile(url)) {
            $j.Ui.Toast.show('warning', '앱에서만 공유 가능합니다.');
        }
    }

    _onDownloadClick() {
        const item = this.items[this.index];
        if (!item) return;
        const url = item.url || Util.getImageUrl(item.path, item.host, 'original');
        $j.F.App.downloadImage(url);
    }

    /**
     * 액션 버튼 줄을 걷는다. 한 번만 할 수 있는 일(예: 1회성 포인트 지급)을 마친 뒤
     * 열려있는 뷰어에서 같은 버튼을 다시 누르지 못하게 할 때 호출한다.
     */
    hideActions() {
        this.actions = [];
        if (this.$ov) this.$ov.find('.mc-fullscreen-actions').remove();
    }

    /**
     * 열린 뷰어의 항목 하나를 바꾼다. where = index 또는 (item => bool).
     * 지금 보고 있는 사진이면 그림만 바꿔 끼운다 — 확대 상태를 풀지 않는다(작은 그림 → 큰 그림 갈아 끼우기).
     */
    updateItem(where, patch) {
        if (!patch) return;
        const i = typeof where === 'function' ? this.items.findIndex(where) : where;
        const item = this.items[i];
        if (!item) return;
        Object.assign(item, patch);
        if (!this.$ov || i !== this.index) return;
        if (patch.url || patch.path) {
            const img = this.$ov.find('img')[0];
            if (img) img.src = item.url || Util.getImageUrl(item.path, item.host, 'original');
        }
    }

    /** 버튼 글자(함수면 지금 사진으로 계산) */
    _actionLabel(a) {
        if (typeof a.label !== 'function') return String(a.label);
        const item = this.items[this.index];
        return item ? String(a.label(item, this.index) || '') : '';
    }

    /** 버튼 글자·눌림을 지금 사진 기준으로 다시 그린다 — 넘길 때, 누른 뒤. 글자를 준 버튼은 같은 글자 그대로 */
    _refreshActions() {
        if (!this.$ov) return;
        const item = this.items[this.index];
        if (!item) return;
        this.$ov.find('.mc-fullscreen-action, .mc-fullscreen-dock-btn').each((_, el) => {
            const a = this.actions[parseInt(el.getAttribute('data-act'), 10)];
            if (!a) return;
            el.textContent = this._actionLabel(a);
            if (typeof a.pressed === 'function') {
                const on = !!a.pressed(item, this.index);
                el.classList.toggle('is-on', on);
                el.setAttribute('aria-pressed', on ? 'true' : 'false');
            }
        });
    }

    /** 액션 버튼 — 지금 보고 있는 사진을 그대로 넘긴다 (갤러리에서 넘긴 뒤 눌러도 맞게) */
    _onActionClick(i) {
        const action = this.actions[i];
        const item = this.items[this.index];
        if (!action || !item) return;
        action.onClick(item, this.index);
        this._refreshActions();   // 누른 뒤 상태(예: 선택됨)를 다시 그린다 — onClick 이 닫았으면 아무것도 안 한다
    }

    _esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    _onDeleteClick() {
        const idx = this.index;
        const item = this.items[idx];
        if (!item) return;
        const self = this;
        Util.swalert('이 사진을 삭제하시겠습니까?', () => {
            $j.Common.EventBus.trigger('zoomphoto:delete', { index: idx, item });

            // 내부 상태도 즉시 갱신
            self.items.splice(idx, 1);
            if (!self.items.length) {
                self.close();
            } else {
                self.index = Math.min(idx, self.items.length - 1);
                self._show();
            }
        }, ['예', '아니오']);
    }

    // ─── 이벤트 바인딩 ─────────────────────────
    _bind() {
        const self = this;
        const $ov = this.$ov;
        const img = $ov.find('img')[0];

        $ov.on('click', 'button', (e) => { e.preventDefault(); e.stopPropagation(); e.currentTarget.blur(); });
        $ov.find('.mc-fullscreen-close').on('click', () => self.close());
        // 창 크기가 바뀌면 사진 크기도 바뀐다 — 닫기 버튼을 따라 옮긴다 ('fit' 전용)
        if (this.size === 'fit') {
            this._onResize = () => self._placeClose();
            $(window).on('resize.zoomphoto', this._onResize);
        }
        $ov.find('.mc-fullscreen-del').on('click', () => self._onDeleteClick());
        $ov.find('.mc-fullscreen-share').on('click', () => self._onShareClick());
        $ov.find('.mc-fullscreen-download').on('click', () => self._onDownloadClick());
        $ov.on('click', '.mc-fullscreen-action, .mc-fullscreen-dock-btn', function () {
            self._onActionClick(parseInt($(this).data('act')));
        });
        $ov.find('.mc-fullscreen-nav.prev').on('click', () => self._step(-1));
        $ov.find('.mc-fullscreen-nav.next').on('click', () => self._step(1));

        // 핀치/팬 + 휠 줌
        let scale = 1, lastScale = 1;
        let posX = 0, posY = 0, lastPosX = 0, lastPosY = 0;
        let startDist = 0, startX = 0, startY = 0, moved = false;

        function dist(t) {
            const dx = t[0].clientX - t[1].clientX;
            const dy = t[0].clientY - t[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function apply() {
            img.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
        }

        this._resetZoom = function () {
            scale = 1; lastScale = 1;
            posX = 0; posY = 0; lastPosX = 0; lastPosY = 0;
            apply();
        };

        img.addEventListener('touchstart', function (e) {
            moved = false;
            if (e.touches.length === 2) {
                e.preventDefault();
                startDist = dist(e.touches);
            } else if (e.touches.length === 1 && lastScale > 1) {
                startX = e.touches[0].clientX - lastPosX;
                startY = e.touches[0].clientY - lastPosY;
            }
        }, { passive: false });

        img.addEventListener('touchmove', function (e) {
            moved = true;
            if (e.touches.length === 2) {
                e.preventDefault();
                scale = Math.min(Math.max(lastScale * (dist(e.touches) / startDist), 1), 5);
                apply();
            } else if (e.touches.length === 1 && scale > 1) {
                e.preventDefault();
                posX = e.touches[0].clientX - startX;
                posY = e.touches[0].clientY - startY;
                apply();
            }
        }, { passive: false });

        img.addEventListener('touchend', function (e) {
            if (e.touches.length === 0) {
                lastScale = scale;
                lastPosX = posX;
                lastPosY = posY;
                if (scale <= 1) { posX = 0; posY = 0; lastPosX = 0; lastPosY = 0; }
            }
        });

        img.addEventListener('wheel', function (e) {
            e.preventDefault();
            const delta = e.deltaY > 0 ? 0.9 : 1.1;
            scale = Math.min(Math.max(scale * delta, 1), 5);
            if (scale <= 1) { posX = 0; posY = 0; lastPosX = 0; lastPosY = 0; }
            lastScale = scale;
            apply();
            img.style.cursor = scale > 1 ? 'grab' : '';
        }, { passive: false });

        // 마우스 드래그 팬 (PC) — 확대 상태에서만 작동.
        // mousemove/mouseup 은 document 에 바인딩해서 이미지 영역 밖으로 나가도 추적.
        let isDragging = false;
        $(img).on('mousedown.zoomphoto', function (e) {
            if (e.button !== 0 || scale <= 1) return;
            e.preventDefault();
            isDragging = true;
            moved = false;
            startX = e.clientX - lastPosX;
            startY = e.clientY - lastPosY;
            img.style.cursor = 'grabbing';
        });
        $(document).on('mousemove.zoomphoto', function (e) {
            if (!isDragging) return;
            moved = true;
            posX = e.clientX - startX;
            posY = e.clientY - startY;
            apply();
        });
        $(document).on('mouseup.zoomphoto', function () {
            if (!isDragging) return;
            isDragging = false;
            lastScale = scale;
            lastPosX = posX;
            lastPosY = posY;
            img.style.cursor = scale > 1 ? 'grab' : '';
        });

        // 좌우 스와이프로 이전/다음 — 옵션 없이 늘 켜진다. 확대 중(한 손가락은 이동)·두 손가락(핀치)·한 장일 때는 넘기지 않는다.
        // 미는 동안 사진이 손을 따라오고, 화면 폭의 15%(최소 50px)를 넘겨 놓으면 넘어간다. 못 미치면 제자리로 돌아온다.
        // 버튼 위에서 시작한 터치는 버튼 몫이다. loop:false 의 끝에서는 _step 이 무시하므로 제자리로 돌아온다.
        let swipeX = 0, swipeY = 0, swiping = false, swipeDx = 0;
        const ov = $ov[0];
        ov.addEventListener('touchstart', function (e) {
            swiping = e.touches.length === 1 && lastScale <= 1 && self.items.length > 1 && !$(e.target).closest('button').length;
            if (!swiping) return;
            swipeX = e.touches[0].clientX;
            swipeY = e.touches[0].clientY;
            swipeDx = 0;
            img.style.transition = '';
        }, { passive: true });
        ov.addEventListener('touchmove', function (e) {
            if (!swiping) return;
            if (e.touches.length !== 1 || scale > 1) { swiping = false; self._resetZoom(); return; }
            const dx = e.touches[0].clientX - swipeX, dy = e.touches[0].clientY - swipeY;
            if (!swipeDx && Math.abs(dy) > Math.abs(dx)) { swiping = false; return; }   // 세로로 먼저 움직이면 스와이프가 아니다
            swipeDx = dx;
            moved = true;
            img.style.transform = `translate(${dx}px, 0) scale(1)`;
        }, { passive: true });
        ov.addEventListener('touchcancel', function () {
            if (!swiping) return;
            swiping = false;
            self._resetZoom();
        });
        ov.addEventListener('touchend', function () {
            if (!swiping) return;
            swiping = false;
            const before = self.index;
            if (Math.abs(swipeDx) >= Math.max(50, window.innerWidth * 0.15)) self._step(swipeDx < 0 ? 1 : -1);
            if (self.index === before) {   // 못 넘겼다 — 제자리로
                img.style.transition = 'transform .15s ease-out';
                self._resetZoom();
                setTimeout(() => { img.style.transition = ''; }, 160);
            }
        });

        // 배경 탭 → 닫기 (줌 안된 상태)
        $ov.on('click', function (e) {
            if (e.target === this && !moved && scale <= 1) self.close();
        });

        // 키보드 (PC)
        $(document).on('keydown.zoomphoto', function (e) {
            if (!self.$ov) return;
            if (e.key === 'Escape') self.close();
            else if (e.key === 'ArrowLeft') self._step(-1);
            else if (e.key === 'ArrowRight') self._step(1);
        });
    }
}
